import { tickerItems } from "@/mocks/homeData";

export default function TopTicker() {
  const loopItems = [...tickerItems, ...tickerItems];

  return (
    <div className="w-full bg-primary-600 text-background-50">
      <div className="flex items-stretch">
        <div className="flex shrink-0 items-center gap-2 bg-primary-700 px-4 py-2 md:px-6">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-400 opacity-75"></span>
            <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-400"></span>
          </span>
          <span className="zone-label whitespace-nowrap text-[11px] font-medium">实时更新</span>
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="ticker-track flex w-max items-center py-2">
            {loopItems.map((item, i) => (
              <span
                key={`${item}-${i}`}
                className="mx-5 whitespace-nowrap text-[11px] text-background-50/90 md:mx-7 md:text-xs"
              >
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}